// Boolean URL flags follow a presence-based house style: a flag is "on"
// whenever its param is present, regardless of value.
// Flags serialize bare (?edit), never ?edit=.

export const hasFlag = (searchParams, name) => searchParams.has(name);

// Serialize params to a query string (no leading '?') with presence-only flags
// rendered as bare keys — the '=' separator is dropped for any empty value.
export const flagsToString = (searchParams) => searchParams.toString().replace(/=(?=&|$)/g, '');

// A query string (no leading '?') with the flag added, preserving other params
// and rendering the flag bare.
export const withFlag = (searchParams, name) => {
  const next = new URLSearchParams(searchParams);
  next.set(name, '');
  return flagsToString(next);
};

// A new URLSearchParams with the flag removed — pass to setSearchParams to
// consume a one-shot flag so a refresh or back-navigation doesn't re-trigger it.
export const withoutFlag = (searchParams, name) => {
  const next = new URLSearchParams(searchParams);
  next.delete(name);
  return next;
};
